import styled from 'styled-components'

const LoadingWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
`

export default LoadingWrapper
